"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[13110],{

/***/ 16998:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      border: 1px solid ",
        ";\n      color: ",
        ";\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      background-color: ",
        ";\n      color: ",
        ";\n      font-weight: 700;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      background-color: ",
        ";\n      color: ",
        ";\n      font-weight: 700;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      border: 1px solid ",
        ";\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding: 2px 5px;\n      font-size: 11px;\n      line-height: 1;\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding: 1px 5px;\n      font-size: 12px;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding: 0 6px;\n      font-size: 12.5px;\n      line-height: 20px;\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding: 0 8px;\n      font-size: 14px;\n      line-height: 25px;\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  ",
        "\n  margin: ",
        ';\n  font-family: "ProximaNovaRg";\n  border-radius: 2px;\n  display: inline-block;\n  text-align: center;\n'
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: inline-block;\n  background-color: ",
        ";\n  text-align: center;\n  height: 30px;\n  padding: 0 10px;\n  border-left: 5px solid;\n  border-left-color: ",
        ";\n  animation-duration: 0.6s;\n  animation-fill-mode: both;\n  animation-timing-function: ease-out;\n  font-weight: bolder;\n  font-size: 18px;\n  line-height: 30px;\n  color: ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}


var tagProps = {
    theme: {
        "outline-primary": (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary),
        grey: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].dimgray */ .Z.dimgray, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light),
        dark: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].nightRider */ .Z.nightRider, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light),
        default: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject3(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro)
    },
    size: {
        xs: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject4()),
        s: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject5()),
        m: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject6()),
        l: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject7())
    }
};
var tagColorByType = {
    up: _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary,
    down: _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].sunsetOrange */ .Z.sunsetOrange,
    neutral: _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].midgray */ .Z.midgray
};
var Tag = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return {
        size: props.size || "m",
        type: props.type || "default",
        margin: props.margin || 0
    };
}).withConfig({
    componentId: "sc-5c2e978b-0"
})(_templateObject8(), function(param) {
    var type = param.type;
    return tagProps.theme[type];
}, function(param) {
    var size = param.size;
    return tagProps.size[size];
}, function(param) {
    var margin = param.margin;
    return margin;
});
var SymbolTag = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return {
        type: props.type || "neutral"
    };
}).withConfig({
    componentId: "sc-5c2e978b-1"
})(_templateObject9(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].highempahis */ .Z.highempahis, function(param) {
    var type = param.type;
    return tagColorByType[type];
}, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light);
/* harmony default export */ __webpack_exports__["Z"] = ({
    Tag: Tag,
    SymbolTag: SymbolTag
});


/***/ }),

/***/ 82495:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Chart; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./node_modules/numeral/numeral.js
var numeral = __webpack_require__(92077);
var numeral_default = /*#__PURE__*/__webpack_require__.n(numeral);
// EXTERNAL MODULE: ./src/features/company/constants.ts
var constants = __webpack_require__(55564);
// EXTERNAL MODULE: ./src/utils/general.js
var general = __webpack_require__(42227);
// EXTERNAL MODULE: ./src/features/company/Chart/styled.ts
var styled = __webpack_require__(33263);
// EXTERNAL MODULE: ./src/features/company/Chart/ExpandButtonToggle.tsx
var ExpandButtonToggle = __webpack_require__(68068);
;// CONCATENATED MODULE: ./src/features/company/Chart/ChartDetail.tsx










function ChartDetail(param) {
    var stateTimeframe = param.timeframe, showTimeframes = param.showTimeframes, _company = param.company, company = _company === void 0 ? {} : _company, chart = param.chart, onSelectTimeframe = param.onSelectTimeframe, onExpand = param.onExpand;
    var _time = company.time, time = _time === void 0 ? "" : _time, companyChange = company.change, companyPercentage = company.percentage, price = company.price, volume = company.volume, average = company.average;
    var ref;
    var timeframe = (ref = chart === null || chart === void 0 ? void 0 : chart.timeframe) !== null && ref !== void 0 ? ref : stateTimeframe;
    var isTimeframeToday = timeframe === "today";
    var change = isTimeframeToday ? companyChange : chart === null || chart === void 0 ? void 0 : chart.change;
    var percentage = isTimeframeToday ? companyPercentage : chart === null || chart === void 0 ? void 0 : chart.percentage;
    var renderTime = (0,react.useCallback)(function() {
        if (timeframe === "today") {
            var timeOnly = time.slice(4);
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    "Today ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("time", {
                        dateTime: "".concat(timeOnly, "+07:00"),
                        children: "".concat(time, " WIB")
                    })
                ]
            });
        }
        if (timeframe === "ytd") {
            return "Year to Date";
        }
        if (timeframe[1] === "w") {
            return "Past ".concat(timeframe[0], " Week");
        }
        if (timeframe[1] === "m") {
            return "Past ".concat(timeframe[0], " Month");
        }
        if (timeframe[1] === "y") {
            return "Past ".concat(timeframe[0], " Year");
        }
        return "";
    }, [
        timeframe,
        time
    ]);
    var numeralChange = (0,react.useMemo)(function() {
        return numeral_default()(change);
    }, [
        change
    ]);
    var priceType = (0,react.useMemo)(function() {
        if (numeralChange.value() > 0) return "up";
        if (numeralChange.value() < 0) return "down";
        return "netral";
    }, [
        numeralChange
    ]);
    var formattedPrice = (0,react.useMemo)(function() {
        return numeral_default()(price).format("0,0.[00]");
    }, [
        price
    ]);
    var formattedChange = (0,react.useMemo)(function() {
        var val = numeralChange.value();
        if (Number.isNaN(val)) return "NA";
        if (val === 0) return "0.00";
        return numeralChange.format("+0,0.[00]");
    }, [
        numeralChange
    ]);
    var formattedPercentage = (0,react.useMemo)(function() {
        return numeral_default()(percentage || 0).format("0.00");
    }, [
        percentage
    ]);
    var formattedVolume = (0,react.useMemo)(function() {
        return Number.isNaN(volume) ? "NA" : (0,general/* parseCountAbbrv2 */.St)(volume);
    }, [
        volume
    ]);
    var formattedAvgVolume = (0,react.useMemo)(function() {
        return Number.isNaN(Number(average)) ? "NA" : (0,general/* parseCountAbbrv2 */.St)(parseInt(String(average), 10));
    }, [
        average
    ]);
    var isNAorZero = (0,react.useMemo)(function() {
        return [
            "NA",
            "0",
            "0.00"
        ].includes(String(formattedAvgVolume));
    }, [
        formattedAvgVolume
    ]);
    var renderPriceTime = function() {
        var ref, ref1, ref2, ref3, ref4;
        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    align: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ResponsiveText */.lz, {
                            as: "h3",
                            family: "bold",
                            margin: "0px",
                            padding: "0px",
                            children: formattedPrice
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* CustomIconmoon */.mJ, {
                            as: "span",
                            className: constants/* priceChange */.lt === null || constants/* priceChange */.lt === void 0 ? void 0 : (ref = constants/* priceChange */.lt[priceType]) === null || ref === void 0 ? void 0 : ref.icon,
                            color: constants/* priceChange */.lt === null || constants/* priceChange */.lt === void 0 ? void 0 : (ref1 = constants/* priceChange */.lt[priceType]) === null || ref1 === void 0 ? void 0 : ref1.color,
                            hoverColor: constants/* priceChange */.lt === null || constants/* priceChange */.lt === void 0 ? void 0 : (ref2 = constants/* priceChange */.lt[priceType]) === null || ref2 === void 0 ? void 0 : ref2.color
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ResponsiveText */.lz, {
                            as: "h3",
                            color: constants/* priceChange */.lt === null || constants/* priceChange */.lt === void 0 ? void 0 : (ref3 = constants/* priceChange */.lt[priceType]) === null || ref3 === void 0 ? void 0 : ref3.color,
                            px: "5px",
                            children: formattedChange
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ResponsiveText */.lz, {
                            as: "h3",
                            color: constants/* priceChange */.lt === null || constants/* priceChange */.lt === void 0 ? void 0 : (ref4 = constants/* priceChange */.lt[priceType]) === null || ref4 === void 0 ? void 0 : ref4.color,
                            children: "(".concat(formattedPercentage, "%)")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* TimeText */.LC, {
                    as: "span",
                    color: color/* default.midgray */.Z.midgray,
                    size: "12px",
                    pt: "3px",
                    children: renderTime()
                })
            ]
        });
    };
    var renderVolume = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* ChartSectionItem */.nJ, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "h3",
                    size: "16px",
                    children: formattedVolume
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    color: color/* default.midgray */.Z.midgray,
                    size: "12px",
                    pt: "3px",
                    children: "Volume"
                })
            ]
        });
    };
    var renderAvgVolume = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* ChartSectionItem */.nJ, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    as: "h3",
                    size: "16px",
                    children: formattedAvgVolume
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    color: color/* default.midgray */.Z.midgray,
                    size: "12px",
                    pt: "3px",
                    children: "Avg volume"
                })
            ]
        });
    };
    var renderTimeframeButtonsMobile = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* TimeframeButtonsMobile */.yX, {
            showTimeframes: showTimeframes,
            timeframe: timeframe,
            onSelectTimeframe: onSelectTimeframe,
            timeFrameList: constants/* chartTimeframes */.Iv
        });
    };
    var renderExpandButtonToggle = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandButtonToggle/* default */.Z, {
            onExpand: onExpand
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        align: "center",
        justify: "space-between",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                children: [
                    renderPriceTime(),
                    renderVolume(),
                    !isNAorZero && renderAvgVolume()
                ]
            }),
            renderTimeframeButtonsMobile(),
            renderExpandButtonToggle()
        ]
    });
}
/* harmony default export */ var Chart_ChartDetail = (ChartDetail);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/react-chartjs-2/dist/index.modern.js + 1 modules
var index_modern = __webpack_require__(508);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
;// CONCATENATED MODULE: ./src/features/company/Chart/CompanyChart.tsx








var fillColor = color/* default.clearDay */.Z.clearDay;
var lineColor = color/* default.mountainMeadow */.Z.mountainMeadow;
function CompanyChart(param) {
    var chart = param.chart, companyType = param.companyType, onClickChart = param.onClickChart;
    var ref = chart !== null && chart !== void 0 ? chart : {}, tmp = ref.prices, chartPrices = tmp === void 0 ? [] : tmp, tmp1 = ref.previous_timeframe_price, previousPrices = tmp1 === void 0 ? null : tmp1, timeframe = ref.timeframe, _previous = ref.previous, previous = _previous === void 0 ? 0 : _previous;
    var isRdn = (companyType === null || companyType === void 0 ? void 0 : companyType.toLowerCase()) === "reksadana";
    var isSelectedTimeframe = [
        "ytd",
        "1w"
    ].includes(timeframe);
    var prices = (0,react.useMemo)(function() {
        if (isSelectedTimeframe && previousPrices && !isRdn && companyType) {
            // case delisting stock and no prices available
            if (chartPrices.length === 0 && !previousPrices.value && previous) {
                var previousPrice = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, previousPrices), {
                    value: previous.toString(),
                    date: "0"
                });
                return [
                    previousPrice,
                    previousPrice
                ];
            }
            if (previousPrices.value) {
                return [
                    previousPrices
                ].concat((0,_to_consumable_array/* default */.Z)(chartPrices));
            }
            return chartPrices;
        }
        return chartPrices;
    }, [
        chartPrices,
        previousPrices,
        timeframe,
        isRdn
    ]);
    var createPreviousMonth = function(numberOfMonth) {
        var data = [];
        var dateStart = moment_default()().subtract(numberOfMonth, "month");
        var dateEnd = moment_default()();
        while(dateStart.diff(dateEnd, "months") <= 0){
            data.push(dateStart.format("MMM YYYY"));
            dateStart.add(1, "month");
        }
        return data;
    };
    var createPreviousYear = function(numberOfYear) {
        var data = [];
        var dateStart = moment_default()().subtract(numberOfYear, "y");
        var dateEnd = moment_default()();
        while(dateStart.diff(dateEnd, "years") <= 0){
            data.push(dateStart.format("YYYY"));
            dateStart.add(1, "year");
        }
        return data;
    };
    var ref1 = (0,react.useMemo)(function() {
        if (timeframe === "1w") return [
            "DD MMM",
            5,
            []
        ];
        if (timeframe === "1m") return [
            "DD MMM",
            5,
            []
        ];
        if (timeframe === "3m") {
            var previousMonths = createPreviousMonth(2);
            return [
                "MMM",
                3,
                previousMonths
            ];
        }
        if (timeframe === "ytd") return [
            "DD MMM",
            5
        ];
        if (timeframe === "1y") {
            var previousMonths1 = createPreviousMonth(11);
            return [
                "MMM",
                12,
                previousMonths1,
                false
            ];
        }
        if (timeframe === "3y") {
            var previousYear = createPreviousYear(2);
            return [
                "YYYY",
                3,
                previousYear
            ];
        }
        if (timeframe === "5y") {
            var previousYear1 = createPreviousYear(4);
            return [
                "YYYY",
                5,
                previousYear1
            ];
        }
        return [
            "HH:mm",
            6,
            []
        ];
    }, [
        timeframe
    ]), format = ref1[0], maxTicks = ref1[1], labels = ref1[2], tmp2 = ref1[3], autoSkip = tmp2 === void 0 ? true : tmp2;
    var tempLabels = [];
    var chartData = (0,react.useMemo)(function() {
        return {
            labels: prices.map(function(price, index) {
                if (!price.formatted_date && price.date === "0") return "";
                if (isSelectedTimeframe && (previousPrices === null || previousPrices === void 0 ? void 0 : previousPrices.value) && index === 0 && !isRdn) {
                    return "";
                }
                var formattedDate = moment_default()(price.formatted_date);
                var monthYear = formattedDate.format("MMM YYYY");
                var month = formattedDate.format("MMM");
                var year = formattedDate.format("YYYY");
                var formattedByTimeframe = formattedDate.format(format);
                switch(timeframe){
                    case "1w":
                        if (formattedDate.hour() <= 9 && !tempLabels.includes(formattedByTimeframe)) {
                            tempLabels.push(formattedByTimeframe);
                            return formattedByTimeframe;
                        }
                        return "";
                    case "1m":
                    case "today":
                        return formattedDate.minute() === 0 ? formattedByTimeframe : "";
                    case "3m":
                    case "1y":
                        if (labels.includes(monthYear)) {
                            labels.splice(labels.indexOf(monthYear), 1);
                            return month;
                        }
                        return "";
                    case "3y":
                    case "5y":
                        if (labels.includes(year)) {
                            labels.splice(labels.indexOf(year), 1);
                            return year;
                        }
                        return "";
                    case "ytd":
                        return formattedByTimeframe;
                    default:
                        return moment_default()(price.formatted_date).format(format);
                }
            }),
            datasets: [
                {
                    fill: true,
                    tension: 0,
                    backgroundColor: fillColor,
                    borderColor: lineColor,
                    borderCapStyle: "butt",
                    borderDashOffset: 0.0,
                    borderDash: [],
                    borderJoinStyle: "round",
                    borderWidth: 2,
                    data: prices.map(function(pr) {
                        return parseInt(pr.value, 10);
                    })
                }, 
            ]
        };
    }, [
        prices,
        format,
        isRdn
    ]);
    var options = (0,react.useMemo)(function() {
        return {
            animation: {
                duration: 0
            },
            resizeDelay: 0,
            plugins: {
                legend: {
                    display: false
                },
                tooltip: {
                    enabled: false
                }
            },
            maintainAspectRatio: false,
            scales: {
                y: {
                    position: "right",
                    grid: {
                        display: false,
                        drawBorder: false
                    },
                    ticks: {
                        maxTicksLimit: 8,
                        callback: function callback(val) {
                            var price = val;
                            // if price contain decimal, then hide tick
                            if (typeof price === "number" && price % 1 !== 0) price = null;
                            return price || null;
                        }
                    }
                },
                x: {
                    grid: {
                        display: false
                    },
                    ticks: {
                        align: "start",
                        maxTicksLimit: maxTicks,
                        maxRotation: 0,
                        callback: function callback(val) {
                            // eslint-disable-next-line react/no-this-in-sfc
                            return this.getLabelForValue(val) || null;
                        },
                        autoSkip: autoSkip,
                        precision: 0
                    }
                }
            },
            elements: {
                point: {
                    radius: 0
                }
            },
            events: [
                "click"
            ],
            onClick: onClickChart
        };
    }, [
        maxTicks,
        onClickChart
    ]);
    var finalChartData = (0,react.useMemo)(function() {
        if (prices.length === 0) {
            return {
                datasets: [
                    {
                        data: [
                            previous,
                            previous
                        ],
                        borderColor: "#E5E5E5",
                        borderDash: [
                            4,
                            4
                        ],
                        borderWidth: 1,
                        fill: false
                    }, 
                ],
                labels: [
                    "",
                    ""
                ]
            };
        }
        return chartData;
    }, [
        chartData,
        previous,
        prices,
        timeframe
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_modern/* Line */.x1, {
        data: finalChartData,
        options: options,
        height: 300
    });
}
/* harmony default export */ var Chart_CompanyChart = (CompanyChart);

// EXTERNAL MODULE: ./src/features/company/Chart/EmptyChart.tsx + 1 modules
var EmptyChart = __webpack_require__(19970);
;// CONCATENATED MODULE: ./src/features/company/Chart/MainChart.tsx






function MainChart(param) {
    var visible = param.visible, symbol = param.symbol, timeframe = param.timeframe, showTimeframes = param.showTimeframes, onSelectTimeframe = param.onSelectTimeframe, isLoadingChart = param.isLoadingChart, chart = param.chart, onClickChart = param.onClickChart, disableChartbitLink = param.disableChartbitLink, companyType = param.companyType;
    return !visible ? null : /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* MainChartWrapper */.yd, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* TimeframeButtonsDesktop */.Kw, {
                showTimeframes: showTimeframes,
                timeframe: timeframe,
                onSelectTimeframe: onSelectTimeframe,
                timeFrameList: constants/* chartTimeframes */.Iv
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* MainChartContent */.LH, {
                children: [
                    chart && /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ChartContainer */.BO, {
                        children: disableChartbitLink ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Chart_CompanyChart, {
                            chart: chart,
                            companyType: companyType,
                            onClickChart: onClickChart
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/symbol/".concat(symbol, "/chartbit"),
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                rel: "noopener noreferrer",
                                target: "_blank",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chart_CompanyChart, {
                                    chart: chart,
                                    companyType: companyType,
                                    onClickChart: onClickChart
                                })
                            })
                        })
                    }),
                    !isLoadingChart && !chart && /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyChart/* default */.Z, {})
                ]
            })
        ]
    });
}
/* harmony default export */ var Chart_MainChart = (MainChart);

;// CONCATENATED MODULE: ./src/features/company/Chart/index.tsx





function ChartV2(param) {
    var _symbol = param.symbol, symbol = _symbol === void 0 ? "" : _symbol, company = param.company, isLoadingChart = param.isLoadingChart, chart = param.chart, timeframe = param.timeframe, isChartVisible = param.isChartVisible, onSelectTimeFrame = param.onSelectTimeFrame, onExpand = param.onExpand, onClickChart = param.onClickChart, disableChartbitLink = param.disableChartbitLink;
    var showDetail = (0,react.useMemo)(function() {
        var ref;
        var whitelistSectors = [
            "index asing",
            "commodities",
            "fx",
            "crypto",
            "index",
            "reksadana",
            "waran",
            "etf",
            "right", 
        ];
        // Pass if sector is whitelisted
        if (whitelistSectors.includes(company === null || company === void 0 ? void 0 : (ref = company.type_company) === null || ref === void 0 ? void 0 : ref.toLowerCase())) {
            return true;
        }
        return !!chart;
    }, [
        chart,
        company
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* ChartWrapper */.hC, {
        as: "section",
        children: [
            showDetail && /*#__PURE__*/ (0,jsx_runtime.jsx)(Chart_ChartDetail, {
                timeframe: timeframe,
                showTimeframes: isChartVisible,
                symbol: symbol,
                onExpand: onExpand,
                company: company,
                chart: chart,
                onSelectTimeframe: onSelectTimeFrame
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Chart_MainChart, {
                timeframe: timeframe,
                showTimeframes: showDetail,
                symbol: symbol,
                onSelectTimeframe: onSelectTimeFrame,
                visible: isChartVisible,
                isLoadingChart: isLoadingChart,
                chart: chart,
                onClickChart: onClickChart,
                disableChartbitLink: disableChartbitLink,
                companyType: company === null || company === void 0 ? void 0 : company.type_company
            })
        ]
    });
}
/* harmony default export */ var Chart = (ChartV2);


/***/ }),

/***/ 13110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ GuestCompany; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/global/SEO/index.tsx
var SEO = __webpack_require__(26350);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/index.tsx + 1 modules
var Post = __webpack_require__(3841);
// EXTERNAL MODULE: ./src/global/StreamWidget/styled.ts
var styled = __webpack_require__(59007);
// EXTERNAL MODULE: ./src/global/StreamWidget/EmptyState/index.tsx + 1 modules
var EmptyState = __webpack_require__(98588);
;// CONCATENATED MODULE: ./src/global/StreamWidget/GuestStream.tsx




/**
 * Stream Widget component
 * @param {string} props.symbol
 */ var GuestStream = function(param) {
    var _posts = param.posts, posts = _posts === void 0 ? [] : _posts, _isCompanyStock = param.isCompanyStock, isCompanyStock = _isCompanyStock === void 0 ? false : _isCompanyStock;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* StreamWidgetBox */.Vd, {
        noBorder: false,
        isCompanyStock: isCompanyStock,
        className: "guest-stream",
        children: posts.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyState/* default */.Z, {
            description: ""
        }) : posts.map(function(post) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Post/* default */.Z, {
                post: post,
                hasFollowingActivity: false,
                entryPoint: "stream"
            }, post.postid);
        })
    });
};
/* harmony default export */ var StreamWidget_GuestStream = (GuestStream);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/constants/app.js
var app = __webpack_require__(86123);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/company/Tag.js
var Tag = __webpack_require__(16998);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./src/utils/number.js
var number = __webpack_require__(62974);
// EXTERNAL MODULE: ./node_modules/numeral/numeral.js
var numeral = __webpack_require__(92077);
var numeral_default = /*#__PURE__*/__webpack_require__.n(numeral);
// EXTERNAL MODULE: ./src/utils/general.js
var general = __webpack_require__(42227);
// EXTERNAL MODULE: ./src/utils/company.ts
var company = __webpack_require__(4168);
// EXTERNAL MODULE: ./node_modules/antd/es/tooltip/index.js + 1 modules
var tooltip = __webpack_require__(56266);
// EXTERNAL MODULE: ./src/global/Notation/IndicatorBar.tsx
var IndicatorBar = __webpack_require__(52491);
// EXTERNAL MODULE: ./src/global/CorpAction/CorpActionBar.tsx
var CorpActionBar = __webpack_require__(88679);
// EXTERNAL MODULE: ./src/utils/tags.tsx + 2 modules
var tags = __webpack_require__(91601);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Button.js
var Button = __webpack_require__(20539);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/device.js
var device = __webpack_require__(74575);
// EXTERNAL MODULE: ./src/global/CorpAction/CorpActionTag.tsx
var CorpActionTag = __webpack_require__(66988);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./src/global/Notation/index.tsx
var Notation = __webpack_require__(15068);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/features/company/Chart/ExpandButtonToggle.tsx
var ExpandButtonToggle = __webpack_require__(68068);
;// CONCATENATED MODULE: ./src/features/company/GuestHeader/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border: 1px solid ",
        ";\n  margin-bottom: 20px;\n  padding: 20px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: block;\n    left: -1px;\n    margin: 0;\n    padding: 0;\n    position: relative;\n    top: -1px;\n    width: calc(100% + 2px);\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 2px 8px;\n  width: 100px;\n\n  @media ",
        " {\n    padding: 4px 15px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n\n  @media ",
        " {\n    flex-direction: row;\n  }\n\n  &.start-center {\n    align-items: flex-start;\n\n    @media ",
        " {\n      align-items: center;\n    }\n  }\n\n  &.end-center {\n    align-items: flex-end;\n\n    @media ",
        " {\n      align-items: center;\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media ",
        " {\n    margin-left: 5px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-transform: lowercase;\n  word-wrap: anywhere;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border-radius: 70px;\n  color: ",
        ";\n  display: flex;\n  margin: auto;\n  min-height: 54px;\n  min-width: 54px;\n\n  > small {\n    font-family: 'Proxima Nova', sans-serif;\n    font-size: 20px;\n    font-weight: 700;\n    line-height: 27px;\n    margin: auto;\n    text-align: center;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  display: inline-block;\n  font-family: "ProximaNovaBd";\n  font-size: 16px;\n  font-weight: bold;\n  margin: 0;\n  max-width: calc(100% - 30px);\n  overflow: hidden;\n  padding: 0;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n'
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n  border-radius: 50%;\n  display: inline-block;\n  height: 18px;\n  margin-left: 10px;\n  width: 18px;\n\n  .mobile {\n    display: block;\n\n    @media ",
        " {\n      display: none;\n    }\n  }\n\n  .desktop {\n    display: none;\n\n    @media ",
        " {\n      display: block;\n    }\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 2px;\n  display: inline-block;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: normal;\n  position: relative;\n  top: -3px;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border: solid 1px rgba(238, 74, 73, 0.5);\n  border-radius: 2px;\n  color: ",
        ";\n  display: inline-block;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: normal;\n  margin-left: 8px;\n  padding: 0px 5px;\n  position: relative;\n  top: -5px;\n  vertical-align: middle;\n\n  > span {\n    font-style: normal;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 5px;\n\n  > h1 {\n    color: ",
        ';\n    font-family: "ProximaNovaRg";\n    font-size: 14px;\n    line-height: 15px;\n    margin: 0;\n    padding: 0;\n  }\n'
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  width: 100%;\n\n  span.catalogs {\n    display: inline-block;\n    font-family: "ProximaNovaRg";\n    font-size: 16px;\n    font-weight: 700;\n    max-width: calc(100% - 30px);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  a {\n    color: ',
        ";\n    display: block;\n    font-size: 12px;\n    font-weight: normal;\n    max-width: 100%;\n    overflow: hidden;\n    padding-right: 7px;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 0;\n  position: relative;\n\n  span {\n    border: 1px solid rgba(0, 171, 107, 0.3);\n    border-radius: 2px;\n    display: inline-block;\n    margin-bottom: 5px;\n    margin-right: 5px;\n    padding: 0 5px;\n    text-align: center;\n  }\n\n  a {\n    display: block;\n    font-weight: normal;\n    padding: 2px 0;\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n margin: 0;\n\n @media ",
        " {\n    margin: auto;\n    margin-top: 5px;\n }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: flex-start;\n  background: ",
        ";\n  border: none;\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  height: auto;\n  line-height: 1.15;\n  min-height: 65px;\n  padding: 17.5px 20px 12.5px;\n  position: relative;\n\n  @media ",
        " {\n    align-items: center;\n    border: 1px solid ",
        ";\n    flex-direction: row;\n    padding: 17.5px 20px 12.5px;\n  }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  margin-left: 4px;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  margin-left: 4px;\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block !important;\n  position: absolute;\n  top: 89px;\n  right: 20px;\n\n  @media ",
        " {\n    display: none !important;\n    position: relative;\n  }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      background-color: ",
        ";\n      flex-direction: column;\n      \n      > a {\n        width: 100%;\n      }\n\n      @media ",
        " {\n        border-left: 1px solid ",
        ";\n        border-right: 1px solid ",
        ";\n        flex-direction: row;\n\n        > div {\n          flex-basis: ",
        ";\n        }\n\n        > a {\n          flex-basis: ",
        ";\n        } \n      }\n    "
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      background-color: transparent;\n    "
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}










var Header = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-eaca74dc-0"
})(_templateObject(), color/* default.light */.Z.light, color/* default.gainsboro */.Z.gainsboro);
var CompanyHeader = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-eaca74dc-1"
})(_templateObject1());
// eslint-disable-next-line space-infix-ops
var CountryFlag = (0,styled_components_browser_esm/* default */.ZP)(Image/* default */.Z).withConfig({
    componentId: "sc-eaca74dc-2"
})(_templateObject2());
var ButtonFollow = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-eaca74dc-3"
})(_templateObject3(), device/* default.tablet */.Z.tablet);
var ColumnMobile = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-eaca74dc-4"
})(_templateObject4(), device/* default.tablet */.Z.tablet, device/* default.tablet */.Z.tablet, device/* default.tablet */.Z.tablet);
var Percentage = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs({
    size: "13px",
    family: "bold"
}).withConfig({
    componentId: "sc-eaca74dc-5"
})(_templateObject5(), device/* default.tablet */.Z.tablet);
var Value = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs({
    size: "18px",
    color: color/* default.black */.Z.black,
    family: "bold"
}).withConfig({
    componentId: "sc-eaca74dc-6"
})(_templateObject6());
var IMAGE_PLACEHOLDER_COLOR = "#3A645C";
var ImagePlaceholder = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-eaca74dc-7"
})(_templateObject7(), IMAGE_PLACEHOLDER_COLOR, color/* default.light */.Z.light);
var Symbol = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    componentId: "sc-eaca74dc-8"
})(_templateObject8());
var NotationCountryFlagContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-eaca74dc-9"
})(_templateObject9());
var CountryFlagContainer = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-eaca74dc-10"
})(_templateObject10(), color/* default.veryLightGrey */.Z.veryLightGrey, device/* default.tablet */.Z.tablet, device/* default.tablet */.Z.tablet);
var NotationContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-eaca74dc-11"
})(_templateObject11());
var Badges = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-eaca74dc-12"
})(_templateObject12(), color/* default.light */.Z.light, color/* default.sunsetOrange */.Z.sunsetOrange);
var CompanyName = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-eaca74dc-13"
})(_templateObject13(), color/* default.highgray */.Z.highgray);
var CompanyNameContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-eaca74dc-14"
})(_templateObject14(), color/* default.primary */.Z.primary);
var CompanyTags = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-eaca74dc-15"
})(_templateObject15());
var ImageWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-eaca74dc-16"
})(_templateObject16(), device/* default.tablet */.Z.tablet);
var CompanyInfoWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-eaca74dc-17"
})(_templateObject17(), color/* default.light */.Z.light, device/* default.tablet */.Z.tablet, color/* default.gainsboro */.Z.gainsboro);
var NewNotationTag = (0,styled_components_browser_esm/* default */.ZP)(Notation/* default */.Z).withConfig({
    componentId: "sc-eaca74dc-18"
})(_templateObject18());
var NewCorpActionTag = (0,styled_components_browser_esm/* default */.ZP)(CorpActionTag/* default */.Z).withConfig({
    componentId: "sc-eaca74dc-19"
})(_templateObject19());
var ExpandButtonToggleMobile = (0,styled_components_browser_esm/* default */.ZP)(ExpandButtonToggle/* default */.Z).withConfig({
    componentId: "sc-eaca74dc-20"
})(_templateObject20(), device/* default.tablet */.Z.tablet);
var NotationCorpActionBarWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-eaca74dc-21"
})(_templateObject23(), // @ts-expect-error
function(param) {
    var isCompanyStock = param.isCompanyStock, isBoth = param.isBoth;
    return isCompanyStock ? (0,styled_components_browser_esm/* css */.iv)(_templateObject21(), color/* default.light */.Z.light, device/* default.tablet */.Z.tablet, color/* default.gainsboro */.Z.gainsboro, color/* default.gainsboro */.Z.gainsboro, isBoth ? "50%" : "auto", isBoth ? "50%" : "auto") : (0,styled_components_browser_esm/* css */.iv)(_templateObject22());
});

;// CONCATENATED MODULE: ./src/features/company/GuestHeader/index.tsx
/* eslint-disable jsx-a11y/anchor-is-valid */ /* eslint-disable jsx-a11y/no-static-element-interactions */ /* eslint-disable jsx-a11y/click-events-have-key-events */ 















var cleanSymbol = company/* default.cleanSymbol */.Z.cleanSymbol;
var SymbolTag = Tag/* default.SymbolTag */.Z.SymbolTag;
var STATUS_LIST = {
    SUSPENDED: "STATUS_SUSPENDED",
    DELISTED: "STATUS_DELISTED"
};
var COMPANY_TYPE_STOCK = "saham";
function GuestHeader(param) {
    var _symbol = param.symbol, symbol = _symbol === void 0 ? "" : _symbol, company = param.company, onClickLink = param.onClickLink;
    var name = company.name, sector = company.sector, volume = company.volume, average = company.average, price = company.price, change = company.change, percentage = company.percentage, time = company.time, followers = company.followers, icon_url = company.icon_url, _country = company.country, country = _country === void 0 ? "ID" : _country, _notation = company.notation, notation = _notation === void 0 ? [] : _notation, uma = company.uma, _corp_action = company.corp_action, corp_action = _corp_action === void 0 ? {} : _corp_action, status = company.status, _catalogs = company.catalogs, catalogs = _catalogs === void 0 ? [] : _catalogs, exchange = company.exchange, _type_company = company.type_company, type_company = _type_company === void 0 ? "" : _type_company;
    var ref = (0,react.useState)(!!icon_url), isIconAvailable = ref[0], setIsIconAvailable = ref[1];
    var isNotationAvailable = !!notation.length;
    var isCorpActionAvailable = corp_action === null || corp_action === void 0 ? void 0 : corp_action.active;
    var isSuspended = status === STATUS_LIST.SUSPENDED;
    var isDelisted = status === STATUS_LIST.DELISTED;
    var isCompanyStock = (type_company === null || type_company === void 0 ? void 0 : type_company.toLowerCase()) === COMPANY_TYPE_STOCK;
    var POPUP_COUNTRY_FLAG_TEXT = "This stock is traded on ".concat(exchange, " exchange");
    var onImgError = function() {
        setIsIconAvailable(false);
    };
    var formattedCountry = country.toLowerCase();
    var IMAGE_URL = "/img/flags/".concat(formattedCountry, ".png");
    var getSectorURL = function(s, subsector) {
        return(// eslint-disable-next-line no-nested-ternary
        !s ? "" : s && s.toLowerCase() !== "indeks" ? "/catalog/".concat((0,general/* convertToSlug */.k6)(s), "/").concat((0,general/* convertToSlug */.k6)(subsector)) : "/catalog/".concat((0,general/* convertToSlug */.k6)(subsector)));
    };
    var onClickCatalogsLink = function(event) {
        event.preventDefault();
        onClickLink();
    };
    var renderCatalogsLink = function(catalogue) {
        var subSectorObject = {
            "Properti & Real Estate": "Properti dan Real Estate",
            Commodities: "Commodity"
        };
        var companySymbol = catalogue.catalog_name || catalogue.company_symbol;
        var companySymbolAlias = subSectorObject[companySymbol] || catalogue.company_symbol;
        var companyType = catalogue.company_type;
        if (companyType === "sub_sector") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: getSectorURL(sector, companySymbolAlias),
                passHref: true,
                onClick: onClickCatalogsLink,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    target: "_blank",
                    rel: "noopener noreferrer",
                    children: companySymbol
                })
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: "/catalog/".concat(companyType, "/").concat(companySymbolAlias),
            passHref: true,
            onClick: onClickCatalogsLink,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                target: "_blank",
                rel: "noopener noreferrer",
                children: companySymbol
            })
        });
    };
    var renderSymbol = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Symbol, {
            children: cleanSymbol(symbol.toUpperCase())
        });
    };
    var renderCompanyLogo = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWrapper, {
            align: "center",
            children: isIconAvailable ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                className: "company-header-icon",
                src: icon_url,
                onError: onImgError,
                alt: symbol,
                width: "54px",
                height: "54px"
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ImagePlaceholder, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                    children: !!symbol && symbol.toUpperCase().slice(0, 1)
                })
            })
        });
    };
    var renderNotationCorpActionBadges = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotationContainer, {
            children: (0,tags/* renderTags */.a)({
                symbol: symbol,
                uma: uma,
                notation: notation,
                corp_action: corp_action
            })
        });
    };
    var renderCountryFlag = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CountryFlagContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CountryFlag, {
                    className: "mobile",
                    src: IMAGE_URL,
                    alt: "".concat(country, " flag")
                }, "country-flag-mobile"),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip/* default */.Z, {
                    className: "desktop",
                    placement: "top",
                    title: POPUP_COUNTRY_FLAG_TEXT,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CountryFlag, {
                        src: IMAGE_URL,
                        alt: "".concat(country, " flag")
                    }, "country-flag-desktop")
                })
            ]
        });
    };
    var renderSuspendedDelistedBadges = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                isSuspended && /*#__PURE__*/ (0,jsx_runtime.jsx)(Badges, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "Suspended"
                    })
                }),
                isDelisted && /*#__PURE__*/ (0,jsx_runtime.jsx)(Badges, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "Delisted"
                    })
                })
            ]
        });
    };
    var renderCompanyName = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyName, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                children: name
            })
        });
    };
    var renderCompanyTags = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyTags, {
            children: catalogs.slice(0, 6).map(function(catalogue) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "catalogs",
                    children: renderCatalogsLink(catalogue)
                }, catalogue.company_symbol);
            })
        });
    };
    var renderExpandButtonToggle = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandButtonToggleMobile, {
            onExpand: onClickCatalogsLink
        });
    };
    var renderNotationCorpActionBar = function(isCompanyStock_) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NotationCorpActionBarWrapper, {
            // @ts-expect-error
            isCompanyStock: isCompanyStock_,
            isBoth: isNotationAvailable && isCorpActionAvailable,
            children: [
                isNotationAvailable && /*#__PURE__*/ (0,jsx_runtime.jsx)(IndicatorBar/* default */.Z, {
                    symbol: symbol,
                    notation: notation,
                    uma: uma,
                    name: name,
                    isGuestCompanyStock: isCompanyStock_,
                    onClick: onClickCatalogsLink
                }),
                isCorpActionAvailable && /*#__PURE__*/ (0,jsx_runtime.jsx)(CorpActionBar/* default */.Z, {
                    symbol: symbol,
                    corpAction: corp_action,
                    isGuestCompanyStock: isCompanyStock_,
                    onClick: onClickCatalogsLink,
                    typeCompany: type_company
                })
            ]
        });
    };
    var renderNonCompanyHeader = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    align: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SymbolTag, {
                        children: symbol.toUpperCase()
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    justify: "space-between",
                    mt: "10px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ColumnMobile, {
                            className: "start-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    size: "24px",
                                    family: "bold",
                                    mr: "10px",
                                    style: {
                                        flex: 1
                                    },
                                    children: name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    color: color/* default.primary */.Z.primary,
                                    size: "14px",
                                    mr: "10px",
                                    children: sector
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/register",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonFollow, {
                                height: "30px",
                                as: "a",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    padding: "0 0 0 5px",
                                    color: color/* default.dimgray */.Z.dimgray,
                                    family: "bold",
                                    children: "Follow"
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    align: "center",
                    mt: "20px",
                    mb: "20px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            as: "div",
                            direction: "column",
                            mr: "20px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ColumnMobile, {
                                    className: "start-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Value, {
                                            children: numeral_default()(price).format("0,0.00")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Percentage, {
                                            color: change > 0 ? color/* default.primary */.Z.primary : color/* default.sunsetOrange */.Z.sunsetOrange,
                                            children: [
                                                change > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                    children: "▴"
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                    children: "▾"
                                                }),
                                                " ",
                                                numeral_default()(change || 0).format("0,0.00"),
                                                " (",
                                                percentage,
                                                ")"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                    size: "13px",
                                    color: color/* default.midgray */.Z.midgray,
                                    mt: "4px",
                                    children: [
                                        "As of ",
                                        time
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            as: "div",
                            direction: "column",
                            mr: "20px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Value, {
                                    children: number/* default.kNumberFormatter */.ZP.kNumberFormatter(volume, 2, true, true)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    size: "13px",
                                    color: color/* default.midgray */.Z.midgray,
                                    mt: "4px",
                                    children: "Volume"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            as: "div",
                            direction: "column",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Value, {
                                    children: number/* default.kNumberFormatter */.ZP.kNumberFormatter(average, 2, true, true)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    size: "13px",
                                    color: color/* default.midgray */.Z.midgray,
                                    mt: "4px",
                                    children: "Avg Volume"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            size: "14px",
                            color: color/* default.dimgray */.Z.dimgray,
                            family: "bold",
                            as: "span",
                            children: numeral_default()(followers || 0).format("0,0")
                        }),
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            size: "14px",
                            color: color/* default.midgray */.Z.midgray,
                            as: "span",
                            children: "Followers"
                        })
                    ]
                })
            ]
        });
    };
    var renderCompanyHeader = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyHeader, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyInfoWrapper, {
                    children: [
                        renderCompanyLogo(),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyNameContainer, {
                            children: [
                                renderSymbol(),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(NotationCountryFlagContainer, {
                                    children: [
                                        renderNotationCorpActionBadges(),
                                        renderCountryFlag(),
                                        renderSuspendedDelistedBadges()
                                    ]
                                }),
                                renderCompanyName(),
                                renderCompanyTags()
                            ]
                        }),
                        renderExpandButtonToggle()
                    ]
                }),
                renderNotationCorpActionBar(isCompanyStock)
            ]
        });
    };
    return isCompanyStock ? renderCompanyHeader() : renderNonCompanyHeader();
}
/* harmony default export */ var company_GuestHeader = (GuestHeader);

// EXTERNAL MODULE: ./src/features/company/styled.ts + 2 modules
var company_styled = __webpack_require__(23391);
// EXTERNAL MODULE: ./src/features/company/GuestRegisterModal/index.tsx + 1 modules
var GuestRegisterModal = __webpack_require__(51129);
// EXTERNAL MODULE: ./src/features/company/constants.ts
var constants = __webpack_require__(55564);
// EXTERNAL MODULE: ./src/features/company/Chart/index.tsx + 3 modules
var Chart = __webpack_require__(82495);
;// CONCATENATED MODULE: ./src/features/company/GuestCompany.tsx











var features = [
    {
        name: "Bandar Detector",
        icon: "icon-feature_bandar"
    },
    {
        name: "Foreign Flow Chart",
        icon: "icon-feature_foreign"
    },
    {
        name: "Valuation Tool",
        icon: "icon-feature_valuation"
    },
    {
        name: "Stock Screener",
        icon: "icon-feature_screener"
    },
    {
        name: "Price-Alert",
        icon: "icon-feature_pricealert"
    },
    {
        name: "Real-time Charting Platform",
        icon: "icon-feature_charting"
    }, 
];
var CompanyGuestStream = function(param) {
    var symbol = param.symbol, posts = param.posts, company = param.company, isCompanyStock = param.isCompanyStock, companyProfile = param.companyProfile, chart = param.chart;
    var DEFAULT_VISIBLE_STATE = !isCompanyStock;
    var ref = (0,react.useState)(DEFAULT_VISIBLE_STATE), visible = ref[0], setVisible = ref[1];
    var _tabs = company.tabs, tabs = _tabs === void 0 ? [] : _tabs, name = company.name;
    var metaTitle = isCompanyStock ? "Saham: ".concat(symbol.toUpperCase(), " - PT. ").concat(name, " | Stockbit") : "Saham ".concat(symbol.toUpperCase(), " (").concat(name, ") | Stockbit");
    var metaDescription = isCompanyStock ? "Informasi detail tentang saham ".concat(symbol.toUpperCase(), " - PT. ").concat(name, " hari ini, mulai dari harga, grafik, data historis dan profil lengkap lainnya.") : "Lihat berita, harga saham, data fundamental, teknikal analisis dan laporan keuangan saham ".concat(symbol.toUpperCase(), " (").concat(name, ") Investasi, Nabung, Beli atau Jual sahamnya secara online dengan mudah.");
    var generateSchemaJson = function() {
        var companyName = company.name, exchange = company.exchange;
        return {
            "@context": "https://schema.org",
            "@type": "Article",
            mainEntityOfPage: {
                "@type": "WebPage",
                "@id": "https://stockbit.com/symbol/".concat(symbol)
            },
            headline: "Saham ".concat(symbol, " - PT. ").concat(companyName, " | Stockbit"),
            image: "",
            author: {
                "@type": "Organization",
                name: "Stockbit",
                url: "https://stockbit.com"
            },
            mentions: [
                {
                    "@type": "Corporation",
                    Legalname: "PT. ".concat(companyName),
                    tickerSymbol: "".concat(exchange, ":").concat(symbol),
                    url: "https://stockbit.com/symbol/".concat(symbol)
                }, 
            ],
            description: "Informasi detail tentang saham ".concat(symbol, " - PT. ").concat(companyName, " hari ini, mulai dari harga, grafik, data historis dan profil lengkap lainnya.")
        };
    };
    var customSymbolMetaKeywords = {
        PANI: "saham pantai indah kapuk, pik 2, saham pani hari ini, pani stock split, aguan, agung sedayu group, saham konglo, saham konglomerat indonesia, analisa saham pani, pemegang saham pani, saham properti, saham sektor properti, emiten properti, perumahan pik",
        PTRO: "saham petrosea, saham prajogo pangestu, saham ptro hari ini, analisa saham ptro, berita saham ptro, berita saham ptro, saham ptro tbk, siapa pemilik petrosea, saham prajogo pangestu apa saja, perusahaan prajogo pangestu, sektor saham energi, perusahaan gas, saham batu bara, industri minyak, jasa konstruksi",
        BREN: "saham BREN hari ini, pemegang saham bren, harga saham bren, dividen bren 2024, analisa saham bren besok, analisa saham bren hari ini, saham bergerak dibidang apa, saham bren milik siapa, prajogo pangestu borong saham bren, laba bren 2024, lapkeu bren 2024, grup barito pacific, sektor energi terbarukan",
        MLPL: "saham MLPL price, dividen saham mlpl 2024, saham mlpl tbk, saham mlpl review, harga wajar saham mlpl, saham mlpl bergerak dibidang apa, multipolar lippo"
    };
    var generateMetaKeywords = function() {
        var symbolKeywords = "".concat(symbol, ", saham ").concat(symbol, ", ").concat(symbol, " saham, idx ").concat(symbol, ", ").concat(symbol, " idx, harga saham ").concat(symbol, ", harga saham ").concat(symbol, " hari ini, saham ").concat(symbol, " hari ini, ").concat(symbol, " saham hari ini, laporan keuangan ").concat(symbol, ", grafik saham ").concat(symbol, ", dividen ").concat(symbol, ", ").concat(symbol, " stock, ").concat(symbol, " hari ini, ").concat(symbol, " saham apa, analisa saham ").concat(symbol, ", saham ").concat(symbol, " bergerak di bidang apa, berita saham ").concat(symbol, ", saham ").concat(symbol, " chart, pemegang saham ").concat(symbol, ", analisis saham ").concat(symbol);
        var companyKeywords = "saham ".concat(name, ", harga saham ").concat(name, ", harga saham ").concat(name, " hari ini, ").concat(name, " saham, harga 1 lot saham ").concat(name, ", grafik saham ").concat(name, ", cara beli saham ").concat(name, ", beli saham ").concat(name, ", kode saham ").concat(name, ", saham ").concat(name, " bergerak di bidang, investasi saham ").concat(name);
        if (customSymbolMetaKeywords[symbol === null || symbol === void 0 ? void 0 : symbol.toUpperCase()] !== undefined) {
            return "".concat(customSymbolMetaKeywords[symbol === null || symbol === void 0 ? void 0 : symbol.toUpperCase()], ", ").concat(symbolKeywords, ", ").concat(companyKeywords);
        }
        return "".concat(symbolKeywords, ", ").concat(companyKeywords);
    };
    var guestCompanyTabs = tabs.filter(function(value) {
        return value !== constants/* TAB_LIST_NAME.NEWS */.p.NEWS;
    }).map(function(value) {
        var newValue = value;
        if (value === constants/* TAB_ANALYST_NEW_NAME */.K1) {
            newValue = constants/* TAB_LIST_NAME.ANALYST */.p.ANALYST;
        }
        return constants/* TAB_LIST */.YS[newValue];
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* default */.Z, {
                title: metaTitle,
                description: metaDescription,
                keywords: isCompanyStock ? generateMetaKeywords() : undefined,
                schemaJson: isCompanyStock ? generateSchemaJson() : null
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(company_GuestHeader, {
                        symbol: symbol,
                        company: company,
                        onClickLink: function() {
                            return setVisible(true);
                        }
                    }),
                    isCompanyStock && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(company_styled/* GuestChartWrapper */.uf, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chart/* default */.Z, {
                                    symbol: symbol,
                                    company: company,
                                    chart: chart,
                                    onSelectTimeFrame: function() {
                                        return setVisible(true);
                                    },
                                    onExpand: function() {
                                        return setVisible(true);
                                    },
                                    onClickChart: function() {
                                        return setVisible(true);
                                    },
                                    isChartVisible: true,
                                    timeframe: "today",
                                    disableChartbitLink: true
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(company_styled/* CustomGuestCompanyBackground */.zj, {
                                companyProfile: companyProfile,
                                onClickReadMore: setVisible
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(company_styled/* GuestNavbar */.rT, {
                        tabs: guestCompanyTabs,
                        active: constants/* TAB_LIST_NAME.STREAM */.p.STREAM,
                        isCompanyStock: isCompanyStock,
                        onClickTab: function() {
                            return setVisible(true);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(company_styled/* GuestStreamWrapper */.Y5, {
                        // @ts-expect-error
                        isCompanyStock: isCompanyStock,
                        justify: "space-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StreamWidget_GuestStream, {
                                posts: posts,
                                isCompanyStock: isCompanyStock
                            }),
                            !isCompanyStock && /*#__PURE__*/ (0,jsx_runtime.jsx)(company_styled/* Banner */.jL, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/register",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "".concat(app/* assetPrefix */.Vc, "/images/sekuritas-banner-right.svg"),
                                            alt: "Daftar"
                                        })
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GuestRegisterModal/* default */.Z, {
                isCompanyStock: isCompanyStock,
                visible: visible,
                setVisible: setVisible,
                features: features
            })
        ]
    });
};
/* harmony default export */ var GuestCompany = (CompanyGuestStream);


/***/ }),

/***/ 88679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22147);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var global_Common_If__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3897);
/* harmony import */ var _CorpActionTag__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66988);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(27691);
/* eslint-disable jsx-a11y/no-static-element-interactions */ /* eslint-disable jsx-a11y/click-events-have-key-events */ /* eslint-disable jsx-a11y/anchor-is-valid */ 







function CorpActionBar(param) {
    var symbol = param.symbol, corpAction = param.corpAction, _isGuestCompanyStock = param.isGuestCompanyStock, isGuestCompanyStock = _isGuestCompanyStock === void 0 ? false : _isGuestCompanyStock, onClick = param.onClick, _typeCompany = param.typeCompany, typeCompany = _typeCompany === void 0 ? "" : _typeCompany;
    var onClickLink = function(event) {
        return isGuestCompanyStock ? onClick(event) : false;
    };
    var formatComma = function(number) {
        return new Intl.NumberFormat("en-US").format(number);
    };
    var getPriceText = function() {
        if (typeCompany.toLowerCase() === "waran") return "Exercise Price";
        if (typeCompany.toLowerCase() === "right") return "Right Issue Price";
        return "";
    };
    var renderText = function() {
        if (corpAction.detail) {
            if (typeCompany.toLowerCase() === "waran" || typeCompany.toLowerCase() === "right") {
                var ref, ref1, ref2, ref3, ref4;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        as: "span",
                        color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].highempahis */ .Z.highempahis,
                        weight: "600",
                        ml: "8px",
                        size: "12px",
                        children: [
                            getPriceText(),
                            ": ",
                            formatComma((ref = corpAction.detail) === null || ref === void 0 ? void 0 : ref.price),
                            " •",
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                style: {
                                    fontWeight: 400
                                },
                                children: [
                                    "Trading End: ",
                                    (ref1 = corpAction.detail) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.trading_end_date) === null || ref2 === void 0 ? void 0 : ref2.formatted,
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(global_Common_If__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                        condition: typeCompany.toLowerCase() === "waran",
                                        children: [
                                            "• Exercise End:",
                                            " ",
                                            (ref3 = corpAction.detail) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.exercise_end_date) === null || ref4 === void 0 ? void 0 : ref4.formatted
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                });
            }
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                as: "span",
                color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].highempahis */ .Z.highempahis,
                weight: "600",
                ml: "8px",
                size: "12px",
                children: "Perusahaan memiliki Corporate Action"
            })
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
        href: "/symbol/".concat(symbol, "/corpaction"),
        passHref: true,
        onClick: onClickLink,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_7__/* .BarWrapper */ .iG, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CorpActionTag__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                corpAction: corpAction
                            }),
                            renderText()
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_7__/* .IconArrow */ .CC, {
                        as: "span"
                    })
                ]
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (CorpActionBar);


/***/ }),

/***/ 52491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95541);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(579);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _Content__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92292);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69836);







var INDICATOR_ICON_URL = "/icon/ic_indicator.svg";
function IndicatorBar(param) {
    var symbol = param.symbol, uma = param.uma, notation = param.notation, name = param.name, _type = param.type, type = _type === void 0 ? "indicator" : _type, _isGuestCompanyStock = param.isGuestCompanyStock, isGuestCompanyStock = _isGuestCompanyStock === void 0 ? false : _isGuestCompanyStock, onClick = param.onClick;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), isVisible = ref[0], setVisible = ref[1];
    var onCloseModal = function() {
        return setVisible(false);
    };
    var onOpenModal = function() {
        return setVisible(true);
    };
    var onClickBar = function(event) {
        // eslint-disable-next-line chai-friendly/no-unused-expressions
        isGuestCompanyStock ? onClick(event) : onOpenModal();
    };
    var renderTag = function(isNotationBadges) {
        return(// @ts-expect-error
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_6__/* .NotationTag */ .GU, {
            type: type,
            isSmall: true,
            isNotationBadges: isNotationBadges,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                alt: "indikator notasi khusus",
                src: INDICATOR_ICON_URL
            })
        }));
    };
    var notationList = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function() {
        return notation.map(function(item) {
            return item === null || item === void 0 ? void 0 : item.notation_code;
        });
    }, [
        notation
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_6__/* .NotationBar */ .H_, {
                align: "center",
                justify: "space-between",
                px: "18px",
                onClick: onClickBar,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        align: "center",
                        justify: "flex-start",
                        children: [
                            renderTag(true),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                as: "span",
                                weight: "600",
                                size: "11px",
                                height: "13.4px",
                                ml: "8px",
                                family: "bold",
                                mr: "6px",
                                children: "Perusahaan memiliki Notasi Khusus"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_6__/* .NotationBadgeContainer */ .Nj, {
                                children: notationList.map(function(code, index) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: [
                                            code,
                                            index < notationList.length - 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                src: "/icon/notsus-badge-dot.svg"
                                            })
                                        ]
                                    });
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        align: "center",
                        justify: "flex-end",
                        style: {
                            cursor: "pointer"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_6__/* .IconArrow */ .CC, {
                            as: "span"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_6__/* .ModalIndicatorBar */ .Qu, {
                visible: isVisible,
                onCancel: onCloseModal,
                title: null,
                centered: true,
                width: "520px",
                bodyStyle: {
                    padding: "16px"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Content__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    symbol: symbol,
                    uma: uma,
                    notation: notation,
                    name: name,
                    notationTag: renderTag(true),
                    isFullsize: true
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (IndicatorBar);


/***/ }),

/***/ 98588:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ StreamWidget_EmptyState; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/PlusOutlined.js + 1 modules
var PlusOutlined = __webpack_require__(24969);
// EXTERNAL MODULE: ./src/global/Common/If.tsx
var If = __webpack_require__(3897);
;// CONCATENATED MODULE: ./src/global/Icons/ComposeSvg.tsx

var ComposeSvg = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.36744 2.26512H2.19276C1.87642 2.26512 1.57304 2.39079 1.34935 2.61447C1.12567 2.83816 1 3.14155 1 3.45789V11.8072C1 12.1236 1.12567 12.427 1.34935 12.6507C1.57304 12.8743 1.87642 13 2.19276 13H10.5421C10.8585 13 11.1618 12.8743 11.3855 12.6507C11.6092 12.427 11.7349 12.1236 11.7349 11.8072V7.63256",
                stroke: "#00AB6B",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.8404 1.37054C11.0776 1.13329 11.3994 1 11.735 1C12.0705 1 12.3923 1.13329 12.6295 1.37054C12.8668 1.6078 13.0001 1.92959 13.0001 2.26512C13.0001 2.60065 12.8668 2.92244 12.6295 3.15969L6.9639 8.82532L4.57837 9.42171L5.17475 7.03618L10.8404 1.37054Z",
                stroke: "#00AB6B",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_ComposeSvg = (ComposeSvg);

// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./src/global/StreamWidget/EmptyState/styled.ts
var styled = __webpack_require__(65299);
;// CONCATENATED MODULE: ./src/global/StreamWidget/EmptyState/index.tsx








function EmptyState(param) {
    var _description = param.description, description = _description === void 0 ? "Add your favourite investors and monitor your stocks" : _description, onDiscover = param.onDiscover, isCurrentUser = param.isCurrentUser;
    var router = (0,next_router.useRouter)();
    if (isCurrentUser !== undefined) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* EmptyStateWrapper */.$c, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Img */.Ei, {
                    src: "/icon/compose-empty.svg",
                    alt: "Empty stream",
                    style: {
                        marginBottom: "16px"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* ContentWrapper */.vs, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            size: "13px",
                            color: "#969696",
                            mb: "20px",
                            children: "Belum ada postingan"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                            condition: isCurrentUser,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* ButtonCompose */.xY, {
                                onClick: function() {
                                    return router.push({
                                        pathname: "/stream",
                                        query: {
                                            compose: "1"
                                        }
                                    });
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_ComposeSvg, {}),
                                    "Tulis Postingan"
                                ]
                            })
                        })
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* EmptyStateWrapper */.$c, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Img */.Ei, {
                src: "/images/empty_stream_box.png",
                alt: "Empty stream"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* ContentWrapper */.vs, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        family: "bold",
                        size: "18px",
                        mb: "10px",
                        children: "Your Stream is Empty"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        size: "16px",
                        color: color/* default.highgray */.Z.highgray,
                        weight: "bold",
                        mb: "32px",
                        children: description
                    }),
                    onDiscover ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* ButtonDiscover */.$A, {
                        onClick: onDiscover,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PlusOutlined/* default */.Z, {
                                style: {
                                    marginRight: "8px"
                                }
                            }),
                            "Discover"
                        ]
                    }) : null
                ]
            })
        ]
    });
}
/* harmony default export */ var StreamWidget_EmptyState = (EmptyState);


/***/ }),

/***/ 90668:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15807);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22147);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2497);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(579);
/* harmony import */ var global_ModalShare__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(41232);
/* harmony import */ var lib_entities_chat_slice__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(10707);
/* harmony import */ var lib_entities_profile__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(333);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(56266);
/* harmony import */ var hooks_useTooltip__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(30627);
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(86123);
/* harmony import */ var features_stream_analytics_StreamTabAnalytics__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(99093);
/* harmony import */ var utils_source__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(9486);
/* harmony import */ var _Modals__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(50700);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(97986);
/* harmony import */ var _slice__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(47225);
/* harmony import */ var _tests_constants__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(18278);
/* eslint-disable no-unused-vars */ 























var LS_TOOLTIP_SHARE = "tooltipShare";
function Footer(param) {
    var post = param.post, onComment = param.onComment, _symbol = param.symbol, symbol = _symbol === void 0 ? "" : _symbol, _hideLikers = param.hideLikers, hideLikers = _hideLikers === void 0 ? false : _hideLikers, _isFirstPost = param.isFirstPost, isFirstPost = _isFirstPost === void 0 ? false : _isFirstPost;
    var pageSource = (0,utils_source__WEBPACK_IMPORTED_MODULE_15__/* .getAnalyticsPageSource */ .u)();
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_7__/* .useDispatch */ .I0)();
    var ref = (0,react_redux__WEBPACK_IMPORTED_MODULE_7__/* .useSelector */ .v9)(lib_entities_profile__WEBPACK_IMPORTED_MODULE_11__/* .selectors */ .wl), profileData = ref.data;
    var _country = profileData.country, country = _country === void 0 ? "ID" : _country;
    var ref1 = (0,hooks_useTooltip__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(LS_TOOLTIP_SHARE), showShareTolltip = ref1.showTooltip, onCloseShareTooltip = ref1.onCloseTooltip;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false), modalShare = ref2[0], showModalShare = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false), modalInsight = ref3[0], showModalInsight = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false), modalTipping = ref4[0], showModalTipping = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false), modalLike = ref5[0], showModalLike = ref5[1];
    var likes = post.likes, replies = post.replies, liked = post.liked, postid = post.postid;
    // TODO: handle logic in footer
    /**
   * - Handle like post -> button after liked/unliked (DONE)
   * - Open modal conversation
   * - Hide tipjar icon if post.userid === current userid
   */ var handleLikePost = function() {
        var action = liked ? _slice__WEBPACK_IMPORTED_MODULE_18__/* .effects.unlikePost */ .Sz.unlikePost : _slice__WEBPACK_IMPORTED_MODULE_18__/* .effects.likePost */ .Sz.likePost;
        // @ts-ignore
        dispatch(action(postid));
    };
    var handleShareToChat = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(chatData) {
            var send, error;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return dispatch(lib_entities_chat_slice__WEBPACK_IMPORTED_MODULE_10__/* .effects.sendBulkChat */ .Sz.sendBulkChat((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)({}, chatData), {
                            attachment_url: "",
                            shared_content: {
                                type: "SHARED_CONTENT_TYPE_STREAM",
                                id: post.postid
                            }
                        })));
                    case 2:
                        send = _ctx.sent;
                        error = send.payload.error;
                        if (!error) {
                            showModalShare(false);
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleShareToChat(chatData) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleClickShare = function() {
        if (pageSource) {
            features_stream_analytics_StreamTabAnalytics__WEBPACK_IMPORTED_MODULE_14__/* ["default"].common.Action.clickShareButton */ .ZP.common.Action.clickShareButton(pageSource);
        }
        showModalShare(true);
    };
    var handleClickTip = function() {
        if (pageSource) {
            features_stream_analytics_StreamTabAnalytics__WEBPACK_IMPORTED_MODULE_14__/* ["default"].common.Action.clickTipping */ .ZP.common.Action.clickTipping({
                pageSource: pageSource,
                streamId: post.postid,
                userId: post.userid
            });
        }
        showModalTipping(true);
    };
    var urlToShare = (0,react__WEBPACK_IMPORTED_MODULE_6__.useMemo)(function() {
        var path = !constants_app__WEBPACK_IMPORTED_MODULE_13__/* .PROJECT_FOLDER */ .sP || constants_app__WEBPACK_IMPORTED_MODULE_13__/* .PROJECT_FOLDER */ .sP === "/" ? "/" : "/".concat(constants_app__WEBPACK_IMPORTED_MODULE_13__/* .PROJECT_FOLDER */ .sP, "/");
        return "".concat(window.location.origin).concat(path, "post/").concat(post.postid);
    }, [
        post
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_17__/* .FooterContainer */ .bk, {
        className: "stream-footer-container",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                justify: "space-between",
                align: "flex-end",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        align: "flex-end",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                children: [
                                    !hideLikers ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        as: "a",
                                        className: "likes-info",
                                        onClick: function() {
                                            return showModalLike(true);
                                        },
                                        children: likes > 0 && "".concat(likes, " likes")
                                    }) : null,
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                        padding: "10px 20px 0 0",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_4__/* .IconWrapper */ .a, {
                                            onClick: handleLikePost,
                                            "data-cy": symbol ? _tests_constants__WEBPACK_IMPORTED_MODULE_22__/* .DATA_CY_FOOTER_LIKE_BUTTON_COMPANY */ .KL : _tests_constants__WEBPACK_IMPORTED_MODULE_22__/* .DATA_CY_FOOTER_LIKE_BUTTON */ .l,
                                            children: liked ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                src: "/icon/post-stream/like-fill.svg",
                                                alt: "Like post filled",
                                                style: {
                                                    width: "20px"
                                                }
                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                src: "/icon/post-stream/like.svg",
                                                alt: "Like post",
                                                style: {
                                                    width: "20px"
                                                }
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                padding: "0 20px 0 0",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                    placement: "top",
                                    title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].light */ .Z.light,
                                        family: "bold",
                                        size: "12px",
                                        height: "22px",
                                        onClick: onCloseShareTooltip,
                                        children: "Share to friends"
                                    }),
                                    defaultVisible: showShareTolltip && isFirstPost,
                                    visible: showShareTolltip && isFirstPost,
                                    overlayClassName: "tooltip-overlay-green",
                                    overlayInnerStyle: {
                                        background: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].primary */ .Z.primary,
                                        padding: "6px 8px"
                                    },
                                    zIndex: 99,
                                    arrowPointAtCenter: true,
                                    onVisibleChange: function(open) {
                                        return onCloseShareTooltip();
                                    },
                                    getPopupContainer: function() {
                                        return(// @ts-expect-error
                                        document.getElementsByClassName("stream-footer-container")[0]);
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_4__/* .IconWrapper */ .a, {
                                        onClick: handleClickShare,
                                        "data-cy": symbol ? _tests_constants__WEBPACK_IMPORTED_MODULE_22__/* .DATA_CY_FOOTER_SHARE_BUTTON_COMPANY */ .H9 : _tests_constants__WEBPACK_IMPORTED_MODULE_22__/* .DATA_CY_FOOTER_SHARE_BUTTON */ .On,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                            src: "/icon/post-stream/share.svg",
                                            alt: "Share post",
                                            style: {
                                                width: "20px"
                                            }
                                        })
                                    })
                                })
                            }),
                            post.analytics && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_4__/* .IconWrapper */ .a, {
                                padding: "0 20px 0 0",
                                onClick: function() {
                                    return showModalInsight(true);
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    className: "icon-new_analytics",
                                    size: "16px",
                                    color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].dimgray */ .Z.dimgray,
                                    hoverColor: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].dimgray */ .Z.dimgray
                                })
                            }),
                            !post.is_author && country === "ID" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_4__/* .IconWrapper */ .a, {
                                padding: "0 20px 0 0",
                                onClick: handleClickTip,
                                "data-cy": symbol ? _tests_constants__WEBPACK_IMPORTED_MODULE_22__/* .DATA_CY_FOOTER_TIP_BUTTON_COMPANY */ .tJ : _tests_constants__WEBPACK_IMPORTED_MODULE_22__/* .DATA_CY_FOOTER_TIP_BUTTON */ .vI,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    src: "/icon/post-stream/icon-tip.svg",
                                    alt: "Icon Tip",
                                    style: {
                                        width: "20px"
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        onClick: onComment,
                        style: {
                            alignItems: "flex-end"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                padding: "0 8px 0",
                                children: parseInt(replies, 10) > 0 && replies
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_4__/* .IconWrapper */ .a, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    src: "/icon/post-stream/comment.svg",
                                    alt: "Icon Comment New",
                                    style: {
                                        width: "20px"
                                    },
                                    "data-cy": symbol ? _tests_constants__WEBPACK_IMPORTED_MODULE_22__/* .DATA_CY_STREAM_COMMENT_ICON_COMPANY */ .dJ : _tests_constants__WEBPACK_IMPORTED_MODULE_22__/* .DATA_CY_STREAM_COMMENT_ICON */ .Vi
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_ModalShare__WEBPACK_IMPORTED_MODULE_9__["default"], {
                post: post,
                sendChat: handleShareToChat,
                title: "Share",
                hasCopyButton: true,
                hasRepostButton: post.is_author === 0,
                hasSearchPeople: true,
                hasSocialMedia: true,
                hasShareInput: true,
                urlToShare: urlToShare,
                visible: modalShare,
                onCancel: function() {
                    return showModalShare(false);
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Modals__WEBPACK_IMPORTED_MODULE_16__/* .ModalInsight */ .eV, {
                visible: modalInsight,
                post: post,
                onCancel: function() {
                    return showModalInsight(false);
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Modals__WEBPACK_IMPORTED_MODULE_16__/* .ModalTipping */ .MW, {
                streamId: postid,
                userId: post.userid,
                username: post.username,
                avatar: post.avatar,
                visible: modalTipping,
                onCancel: function() {
                    return showModalTipping(false);
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Modals__WEBPACK_IMPORTED_MODULE_16__/* .ModalLike */ .gU, {
                likes: likes,
                streamId: postid,
                visible: modalLike,
                onCancel: function() {
                    return showModalLike(false);
                }
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["default"] = (Footer);


/***/ }),

/***/ 82592:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15807);




function PinnedLabel(param) {
    var isCompanyPinnedPost = param.isCompanyPinnedPost, _text = param.text, text = _text === void 0 ? "Pinned Post" : _text, _marginBottom = param.marginBottom, marginBottom = _marginBottom === void 0 ? "16px" : _marginBottom;
    var color = isCompanyPinnedPost ? "#858585" : "#e32072";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        // @ts-expect-error
        ml: isCompanyPinnedPost ? "0px" : "50px",
        align: "center",
        mb: marginBottom,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_3__/* .IconWrapper */ .a, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    className: "icon-toolbar_pinned",
                    size: "16px",
                    color: color
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                ml: isCompanyPinnedPost ? "4px" : "8px",
                color: color,
                children: isCompanyPinnedPost ? "Pinned Post by Stockbit" : text
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (PinnedLabel);


/***/ }),

/***/ 3841:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ StreamWidget_Post; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/global/ImageSlider/index.tsx + 7 modules
var ImageSlider = __webpack_require__(9649);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./src/lib/entities/credentials.js + 4 modules
var credentials = __webpack_require__(21671);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/global/StreamWidget/PollingContainer/index.tsx + 2 modules
var PollingContainer = __webpack_require__(78690);
// EXTERNAL MODULE: ./src/global/StreamWidget/TargetPriceContainer/index.tsx + 2 modules
var TargetPriceContainer = __webpack_require__(18562);
// EXTERNAL MODULE: ./src/global/StreamWidget/TextContent/index.tsx
var TextContent = __webpack_require__(13683);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Avatar.js
var Avatar = __webpack_require__(57788);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/global/Labels/index.tsx + 5 modules
var Labels = __webpack_require__(94493);
// EXTERNAL MODULE: ./src/constants/api.js
var api = __webpack_require__(37213);
// EXTERNAL MODULE: ./src/utils/general.js
var general = __webpack_require__(42227);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/styled.ts
var styled = __webpack_require__(97986);
;// CONCATENATED MODULE: ./src/global/StreamWidget/Post/Comment.tsx














function Comment(_param) {
    var comment = _param.comment, props = (0,_object_without_properties/* default */.Z)(_param, [
        "comment"
    ]);
    var avatar = comment.avatar, content = comment.content, maskedHtml = comment.mask_html, username = comment.username, created = comment.created_display, official = comment.official, isVerified = comment.is_verified, privilege = comment.user_priv;
    var avatarUrl = avatar.startsWith("http") ? avatar : "".concat(api/* AVATAR_URL */.q$, "/").concat(avatar);
    // Note :
    // From backend in stream post the type of official param is number
    // but stream post inside the last_reply have official param type string
    var isOfficial = official > 0 || isVerified;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        style: {
            cursor: "pointer"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* CommentContainer */.bQ, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    mb: "10px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                            size: "x-small",
                            padding: "0 10px 0 0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                alt: "imageProfile",
                                src: avatarUrl,
                                onError: function(e) {
                                    return (0,general/* handleErrorAvatar */.Tk)(e, username);
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    align: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/".concat(username),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* TextHeader */.Y, {
                                                family: "bold",
                                                size: "14px",
                                                children: username
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Labels/* LabelVerifiedAccount */.uC, {
                                            deprecatedVerifiedStatus: isOfficial,
                                            verifiedStatus: comment === null || comment === void 0 ? void 0 : comment.verified_status
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Labels/* LabelAdmin */.SH, {
                                            privilege: privilege
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* TextHeader */.Y, {
                                    size: "12px",
                                    color: color/* default.midgray */.Z.midgray,
                                    children: created
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextContent/* default */.Z, {
                    content: content,
                    maskedHtml: maskedHtml,
                    style: {
                        marginBottom: "0px"
                    },
                    needParsed: false
                })
            ]
        })
    }));
}
/* harmony default export */ var Post_Comment = (Comment);

// EXTERNAL MODULE: ./src/global/StreamWidget/Post/DocumentContainer.tsx
var DocumentContainer = __webpack_require__(55424);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/Header.tsx
var Header = __webpack_require__(5373);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/PinnedLabel.tsx
var PinnedLabel = __webpack_require__(82592);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/RepostBox.tsx
var RepostBox = __webpack_require__(38294);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/TitleContent.tsx + 1 modules
var TitleContent = __webpack_require__(41447);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/YoutubePlayer.tsx
var YoutubePlayer = __webpack_require__(74132);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/Footer.tsx
var Footer = __webpack_require__(90668);
;// CONCATENATED MODULE: ./src/global/StreamWidget/Post/index.tsx
/* eslint-disable react/require-default-props */ /* eslint-disable indent */ /* eslint-disable camelcase */ 





















var GuestFooter = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4597).then(__webpack_require__.bind(__webpack_require__, 4597));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4597)
            ];
        }
    },
    ssr: false,
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var FollowingActivity = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 81895).then(__webpack_require__.bind(__webpack_require__, 81895));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(81895)
            ];
        }
    },
    ssr: false,
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
function Post(param) {
    var post = param.post, onComment = param.onComment, _pinned = param.pinned, pinned = _pinned === void 0 ? false : _pinned, _showLatestComment = param.showLatestComment, showLatestComment = _showLatestComment === void 0 ? true : _showLatestComment, _hasFollowingActivity = param.hasFollowingActivity, hasFollowingActivity = _hasFollowingActivity === void 0 ? true : _hasFollowingActivity, _expandContent = param.expandContent, expandContent = _expandContent === void 0 ? false : _expandContent, _isFirstPost = param.isFirstPost, isFirstPost = _isFirstPost === void 0 ? false : _isFirstPost, _isSinglePost = param.isSinglePost, isSinglePost = _isSinglePost === void 0 ? false : _isSinglePost, _highlightWord = param.highlightWord, highlightWord = _highlightWord === void 0 ? "" : _highlightWord, _symbol = param.symbol, symbol = _symbol === void 0 ? "" : _symbol, entryPoint = param.entryPoint, dataCyName = param.dataCyName;
    var ref, ref1;
    var content = post.content, content_original = post.content_original, images = post.images, attachment = post.attachment, polling = post.polling, target_price = post.target_price, last_reply = post.last_reply, mask_html = post.mask_html, reposted = post.reposted, repostedfrom = post.repostedfrom, title = post.title, titleurl = post.titleurl, images_data = post.images_data, image_frame_type = post.image_frame_type, followingActivity = post.following_activity, isAuthor = post.is_author;
    var isLoggedIn = (0,es/* useSelector */.v9)(credentials/* selectors */.wl).isLoggedIn;
    var imagesData = (0,react.useMemo)(function() {
        var listImage = (images === null || images === void 0 ? void 0 : images.length) > 0 && images[0] !== "" ? images.map(function(i) {
            return {
                image: i
            };
        }) : [];
        listImage = listImage.filter(function(i) {
            var exist = images_data.find(function(img) {
                return img.image === i.image;
            });
            return !exist;
        });
        listImage = (0,_to_consumable_array/* default */.Z)(listImage).concat((0,_to_consumable_array/* default */.Z)(images_data));
        return listImage;
    }, [
        post
    ]);
    var isHaveImage = Boolean((imagesData === null || imagesData === void 0 ? void 0 : imagesData.length) > 0 && ((ref = imagesData[0]) === null || ref === void 0 ? void 0 : ref.image));
    var showFollowingActivity = (followingActivity === null || followingActivity === void 0 ? void 0 : (ref1 = followingActivity.users) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 && hasFollowingActivity;
    var autoplayYoutube = !isSinglePost;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* StreamBoxContainer */.Vj, {
        "data-cy": dataCyName,
        children: [
            pinned && /*#__PURE__*/ (0,jsx_runtime.jsx)(PinnedLabel/* default */.Z, {
                isCompanyPinnedPost: entryPoint === "symbol"
            }),
            showFollowingActivity && /*#__PURE__*/ (0,jsx_runtime.jsx)(FollowingActivity, {
                data: followingActivity
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {
                post: post,
                isLoggedIn: isLoggedIn,
                entryPoint: entryPoint,
                symbol: symbol
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* ContentWrapper */.vs, {
                children: [
                    (polling === null || polling === void 0 ? void 0 : polling.length) && isLoggedIn > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PollingContainer/* default */.Z, {
                        post: post,
                        isSinglePost: isSinglePost,
                        isTextDefaultExpand: expandContent,
                        highlightWord: highlightWord
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* TextContainer */.lU, {
                                children: [
                                    title && titleurl && /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleContent/* default */.Z, {
                                        title: title,
                                        highlightWord: highlightWord,
                                        titleUrl: titleurl
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextContent/* default */.Z, {
                                        content: content,
                                        maskedHtml: mask_html,
                                        isDefaultExpand: expandContent,
                                        highlightWord: highlightWord
                                    }),
                                    post.newsfeed_source && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                alt: post.newsfeed_label,
                                                src: post.newsfeed_img,
                                                style: {
                                                    width: "16px",
                                                    marginRight: "8px"
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                size: "12px",
                                                children: post.newsfeed_label
                                            })
                                        ]
                                    })
                                ]
                            }),
                            isHaveImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageSlider/* default */.Z, {
                                images: imagesData,
                                frameType: image_frame_type,
                                isSinglePost: isSinglePost
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(YoutubePlayer/* default */.Z, {
                                content: content_original,
                                autoplay: autoplayYoutube
                            }),
                            isLoggedIn ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    (attachment === null || attachment === void 0 ? void 0 : attachment.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(DocumentContainer/* default */.Z, {
                                        documents: attachment
                                    }),
                                    (target_price === null || target_price === void 0 ? void 0 : target_price.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(TargetPriceContainer/* default */.Z, {
                                        targetPrice: target_price[0],
                                        postid: post.postid,
                                        isAuthor: isAuthor
                                    })
                                ]
                            }) : null
                        ]
                    }),
                    reposted > 0 && isLoggedIn && /*#__PURE__*/ (0,jsx_runtime.jsx)(RepostBox/* default */.Z, {
                        post: repostedfrom
                    }),
                    isLoggedIn ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer["default"], {
                        post: post,
                        onComment: onComment,
                        isFirstPost: isFirstPost,
                        symbol: symbol
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(GuestFooter, {
                        post: post
                    })
                ]
            }),
            isLoggedIn && showLatestComment && last_reply && Object.keys(last_reply).length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Post_Comment, {
                comment: last_reply,
                onClick: onComment
            })
        ]
    });
}
/* harmony default export */ var StreamWidget_Post = (Post);


/***/ }),

/***/ 59007:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O8": function() { return /* binding */ BackTopWrapper; },
/* harmony export */   "OD": function() { return /* binding */ StreamNewPostText; },
/* harmony export */   "QZ": function() { return /* binding */ StreamWidgetWrapper; },
/* harmony export */   "Vd": function() { return /* binding */ StreamWidgetBox; },
/* harmony export */   "fh": function() { return /* binding */ LineLoader; },
/* harmony export */   "kq": function() { return /* binding */ StreamNewPostBox; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22147);
/* harmony import */ var _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74575);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19521);
/* eslint-disable space-infix-ops */ /* eslint-disable indent */ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n            max-width: 100%;\n          "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          max-width: calc(100% - 330px);\n        "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      border: none;\n      border-radius: 4px;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: ",
        ";\n  border: solid 1px ",
        ";\n  border-radius: ",
        ";\n\n  &.guest-stream {\n    flex: 1;\n    max-width: 100%;\n\n    @media ",
        " {\n      ",
        "\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: ",
        ";\n  border: solid 1px ",
        ";\n  border-bottom: none;\n  cursor: pointer;\n  border-radius: 3px 3px 0 0;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: #a2a7b0; // this is intentionally hardcoded\n  border-radius: 50%;\n  bottom: 25px;\n  color: ",
        ";\n  right: 60px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  from {\n    left: -200px;\n    width: 30%;\n  }\n  50% {\n    width: 30%;\n  }\n  70% {\n    width: 70%;\n  }\n  80% {\n    left: 50%;\n  }\n  95% {\n    left: 120%;\n  }\n  to {\n    left: 100%;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: block;\n  height: 1px;\n  width: 100%;\n  position: absolute;\n  top: 0;\n  overflow: hidden;\n  background-color: #dadada;\n  display: ",
        ";\n\n  :before {\n    position: absolute;\n    content: '';\n    left: -200px;\n    width: 200px;\n    height: 1px;\n    background-color: #00ab6b;\n    animation: ",
        " 2s linear infinite;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  overflow-x: hidden;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}





var StreamWidgetBox = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-655c128c-0"
})(_templateObject3(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].light */ .Z.light, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].gainsboro */ .Z.gainsboro, function(param) {
    var newPostCount = param.newPostCount;
    return newPostCount > 2 ? "0" : "3px";
}, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_4__/* ["default"].tablet */ .Z.tablet, function(param) {
    var isCompanyStock = param.isCompanyStock;
    if (isCompanyStock) {
        return (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject());
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject1());
}, function(param) {
    var noBorder = param.noBorder;
    return noBorder && (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject2());
});
var StreamNewPostBox = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    justify: "center",
    align: "center",
    py: "7px",
    // accessibility props
    role: "button"
}).withConfig({
    componentId: "sc-655c128c-1"
})(_templateObject4(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].light */ .Z.light, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].gainsboro */ .Z.gainsboro);
var StreamNewPostText = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-655c128c-2"
})(_templateObject5(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].primary */ .Z.primary);
var BackTopWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    align: "center",
    height: "40px",
    justify: "center",
    width: "40px"
}).withConfig({
    componentId: "sc-655c128c-3"
})(_templateObject6(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].light */ .Z.light);
var LineAnimation = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .keyframes */ .F4)(_templateObject7());
var LineLoader = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-655c128c-4"
})(_templateObject8(), function(param) {
    var isLoading = param.isLoading;
    return isLoading ? "block" : "none";
}, LineAnimation);
var StreamWidgetWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-655c128c-5"
})(_templateObject9());



/***/ }),

/***/ 91601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* binding */ renderTags; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/global/Notation/index.tsx
var Notation = __webpack_require__(15068);
// EXTERNAL MODULE: ./src/global/CorpAction/CorpActionTag.tsx
var CorpActionTag = __webpack_require__(66988);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/global/Badges/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border: 0.8px solid #f14747;\n  border-radius: 2px;\n  color: ",
        ";\n  display: inline-block;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: normal;\n  padding: 0px 5px;\n  position: relative;\n  vertical-align: middle;\n\n  > span {\n    font-style: normal;\n    font-family: var(--bold-font);\n    line-height: 12px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Badge = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f0777c04-0"
})(_templateObject(), color/* default.light */.Z.light, color/* default.sunsetOrange */.Z.sunsetOrange);

;// CONCATENATED MODULE: ./src/global/Badges/index.tsx


var STATUS_LIST = {
    SUSPENDED: [
        1,
        "STATUS_SUSPENDED"
    ],
    DELISTED: [
        2,
        "STATUS_DELISTED"
    ]
};
function Badges_Badge(param) {
    var status = param.status;
    var isDelisted = STATUS_LIST.DELISTED.includes(status);
    var isSuspended = STATUS_LIST.SUSPENDED.includes(status);
    var renderBadge = function(companyStatus) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: companyStatus
            })
        });
    };
    if (isDelisted) {
        return renderBadge("Delisted");
    }
    if (isSuspended) {
        return renderBadge("Suspended");
    }
    return null;
}
/* harmony default export */ var Badges = (Badges_Badge);

;// CONCATENATED MODULE: ./src/utils/tags.tsx
/* eslint-disable no-undef */ 




var compareValue = function(value, otherValue) {
    return !!value || !!otherValue;
};
/**
 * Render tags notation and corp action
 */ var renderTags = function(company) {
    var showPopover = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, placement = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "top", customContainerStyle = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
        marginLeft: 4,
        gap: 4
    };
    var symbol = company.symbol, symbol_2 = company.symbol_2, _notation = company.notation, notation = _notation === void 0 ? [] : _notation, _corp_action = company.corp_action, corp_action = _corp_action === void 0 ? {} : _corp_action, uma = company.uma, companyName = company.name, _withNotation = company.withNotation, withNotation = _withNotation === void 0 ? 0 : _withNotation, _withUMA = company.withUMA, withUMA = _withUMA === void 0 ? 0 : _withUMA, _withCorpAction = company.withCorpAction, withCorpAction = _withCorpAction === void 0 ? 0 : _withCorpAction, _status = company.status, status = _status === void 0 ? 0 : _status;
    var companySymbol = symbol || symbol_2;
    var showNotation = compareValue((notation === null || notation === void 0 ? void 0 : notation.length) > 0, withNotation);
    var showCorpAction = compareValue(corp_action === null || corp_action === void 0 ? void 0 : corp_action.active, withCorpAction);
    var showUma = compareValue(uma, withUMA);
    var showBadge = status !== 0;
    if (!showBadge && !showCorpAction && !showNotation && !showUma) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        align: "center",
        style: customContainerStyle,
        children: [
            showNotation && /*#__PURE__*/ (0,jsx_runtime.jsx)(Notation/* default */.Z, {
                symbol: companySymbol,
                name: companyName,
                notation: notation,
                uma: false,
                isPopover: showPopover,
                isNotationBadges: true,
                placement: placement
            }),
            showCorpAction && /*#__PURE__*/ (0,jsx_runtime.jsx)(CorpActionTag/* default */.Z, {
                corpAction: company.corp_action,
                isCorpActionBadges: true
            }),
            showBadge && /*#__PURE__*/ (0,jsx_runtime.jsx)(Badges, {
                status: status
            }),
            showUma && /*#__PURE__*/ (0,jsx_runtime.jsx)(Notation/* default */.Z, {
                symbol: companySymbol,
                name: companyName,
                notation: notation,
                uma: showUma,
                isNotationBadges: true,
                type: "uma",
                placement: placement,
                isPopover: false
            })
        ]
    });
};
// eslint-disable-next-line import/prefer-default-export



/***/ })

}]);